import {Box} from "@mui/material";
import React, {FC, ReactElement, useEffect, useMemo, useRef, useState} from "react";
import {createAudioLevelMonitor} from "../utils/MediaStreamMonitor";
import {createAudioContext} from "../contexts/TextToSpeechUtilsPoly";

type AudioLevelProps = {
    deviceId: string | null,
    isInputStream: boolean,
    onAudioLevelAPIReady: (api: AudioLevelAPI) => void
}

const AudioLevel: FC<AudioLevelProps> = ({
                                             deviceId,
                                             isInputStream = false,
                                             onAudioLevelAPIReady
                                         }): ReactElement => {

    const [level, setLevel] = useState<number>(0);
    //const [stopAudioLevelMonitor, setStopAudioLevelMonitor] = useState<Promise<void> | null>();

    const stopAudioLevelMonitor = useRef<() => Promise<void>>();

    const audioLevelAPI: AudioLevelAPI = useMemo(() => {
        // if(!isInputStream || !deviceId)
        //     return null;

        const api = {
            setStreamToMonitor: (audioContext: AudioContext, audioStream: MediaStream) => {

                stopAudioLevelMonitor.current?.();

                if (!audioContext || !audioStream)
                    return;

                stopAudioLevelMonitor.current = createAudioLevelMonitor(audioContext,
                    audioStream,
                    (audioLevelState) => setLevel(audioLevelState.audioLevel));

            }
        };
        onAudioLevelAPIReady(api);
        return api;
    }, []);

    useEffect(() => {
        //Initialize the stream once at first render if it's an input stream (mic)
        //Output stream can only be initialized when the session starts.
        // This is because the mediaStream comes from the text 2 speech processor once the session starts
        if (isInputStream && !!deviceId) {
            // console.log("AudioLevel - deviceId: ", deviceId);
            const micAudioContext = createAudioContext(deviceId) as AudioContext;
            navigator.mediaDevices.getUserMedia({
                audio: {
                    deviceId: {exact: deviceId}
                }
            }).then(mediaStream => {
                // console.log("AudioLevel - mediaStream: ", mediaStream);
                audioLevelAPI.setStreamToMonitor(micAudioContext, mediaStream);
            });
        }

        return () => {
            // console.log("AudioLevel - useEffect - cleanup");
            stopAudioLevelMonitor.current?.();
        }
    }, [deviceId]);

    return <div className='level-control'>
        <div className='level-control-label'>
            {`${isInputStream ? 'Input' : 'Output'} level`}
        </div>
        <div className='level-control-progress'>
            <Box sx={{width: `${level}%`}}
                 className={`level-control-progress-bar ${level === 100 ? 'full' : 'half'}`}/>
            <Box sx={{width: `${100 - level}%`}}
                 className={`level-control-progress-bckg ${level === 0 ? 'full' : 'empty'}`}/>
        </div>
    </div>;

}

export type AudioLevelAPI = {
    setStreamToMonitor: (audioContext: AudioContext,
                         audioStream: MediaStream) => void
}

export default AudioLevel;
